import * as Sentry from "@sentry/react";
import { createBrowserRouter } from "react-router";
import { createAdminRouteObjects } from "./adminRouteObjects.js";
import { appRouteTree, teamMemberAppRouteTree } from "./routeTrees.js";

const createSentryBrowserRouter =
  Sentry.wrapCreateBrowserRouterV7(createBrowserRouter);

export const router = createSentryBrowserRouter(
  createAdminRouteObjects(appRouteTree),
);

export const teamMemberRouter = createSentryBrowserRouter(
  createAdminRouteObjects(teamMemberAppRouteTree),
);
